// URL base de ashara-admin-api (incluye el prefijo /api/v1).
// Se configura con REACT_APP_API_URL en .env.local o en las variables del CI.
export const API_URL = (process.env.REACT_APP_API_URL || "http://localhost:3001/api/v1").replace(/\/+$/, "");
